import React from 'react'
import { FilterTypes } from '../../FilterCommon/Filter';
import { isErrorPc } from '@/component/PageComponent/errorPc';
import { SelectModalCommonPc } from '../Common/SelectListModalPc';
import { activeStatusMap, getPromotionList, getPromotionDetail, PromotionListResp, PromotionWayMap } from './service';
import dayjs from 'dayjs';
import { compact } from 'lodash';
import { getSearchTimestamp } from '@/component/common/report/report';


export interface FilterFullPromotionProps {
  onChange? (value: any, option: any): void
  value: any
}

type RespListRow = PromotionListResp['list'][0];

export function FilterFullPromotion(props: FilterFullPromotionProps) {

  const {...rest} = props
  let listKey = 'promotion_id'

  const getList = async (params: any)=>{
    let res =  await getPromotionList({ 
      ...params
     })
    if(isErrorPc(res)){
      return {
        list: [],
        count: 0,
      }
    }
    const dataList = res.data?.data?.list || [];
    return {
      list: dataList.map(item => ({...item, label: item.name, value: item.promotion_id})),
      count: res.data.data.count
    }
  }

  const getDetail = async (params: { ids: string[] }) => {
    const { ids } = params;
    const promises = ids.map((id) => {
      return getPromotionDetail({
        id
      })
    })
    const results = await Promise.all(promises);
    const detailData = results.map((res) => {
      if(isErrorPc(res)) return undefined
      const dataItem = res.data?.data;
      return {
        label: dataItem.name,
        value: dataItem.promotion_id
      }
    })
    return compact(detailData);
  }

  const defaultValue = {
    start_date: dayjs().subtract(30, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
    end_date: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
  }

  const getComponentKey = () => {
    let componentKey = 'FilterFullPromotion';
    const timeStamp = getSearchTimestamp();
    if (timeStamp) {
      componentKey = componentKey + timeStamp
    }
    return componentKey
  }

  return (
    <SelectModalCommonPc<RespListRow>
      {...rest} 
      listKey={listKey}
      getList={getList}
      getDetail={getDetail}
      defaultValue={defaultValue}
      componentKey={getComponentKey()}
      SelectProps={{
        placeholder: '选择活动',
        mode: 'multiple',
      }}
      SelectListModalProps={{
        listKey:listKey,
        getList: getList,
        type:'checkbox',
        title:'选择活动',
        filterProps: {
          filters: [
            { type: FilterTypes.Input, dataIndex: 'name',placeholder: '活动名称'},
            { type: FilterTypes.RangePick, dataIndex: "start_date,end_date", flex: 2, showTime: true },
            { type: FilterTypes.PromotionWay, dataIndex: 'promotion_type', mode: undefined, allowClear: true },
            { type: FilterTypes.ActivityStatus, dataIndex: 'status', mode: undefined, allowClear: true },
            { type: FilterTypes.PutAway, dataIndex: 'putaway', mode: undefined, allowClear: true },
          ],
        },
        columns: [
          {
            width: 50,
            dataIndex: 'sequence',
            render: (text: string, record: RespListRow, index: number) => {
              return index + 1;
            }
          },
          { width: '25%', title: '活动名称', dataIndex: "name" },
          { 
            width: '40%', 
            title: '开始/结束时间', 
            dataIndex: "start_date", 
            render: (text: string, record: RespListRow) => {
              return (
                <div>
                  <span>{`${record.start_date} ~ ${record.end_date}`}</span>
                </div>
              )
            }
          }, 
          { 
            width: '20%', 
            title: '活动时段', 
            dataIndex: "activeTime",
            render: (text: string, row: RespListRow) => {
              if (row.is_day_loop == 'T') {
                return <span>{`${row.start_time} ~ ${row.end_time}`}</span>
              }
              return '全天'
            }
          },
          { 
            width: '15%', 
            title: '促销方式', 
            dataIndex: "promotion_type",
            render: (text: string) => {
              if (text) {
                return PromotionWayMap[text]
              }
            }
          }, 
          { 
            width: '15%', 
            title: '上下架', 
            dataIndex: "putaway",
            render: (text: string) => {
              return text == 'T' ? '上架' : '下架'
            }
          },
          { 
            width: '15%', 
            title: '活动状态', 
            dataIndex: "status",
            render: (text: string) => {
              return activeStatusMap[text]
            }
          },
        ]
      }}
    />
  )
}
